/// <reference path="multiselect.tmpl.html" />
/// <referen ce path="multiselect.js" />
// Original source: https://github.com/amitava82/angular-multiselect
angular.module('eic.multiselect', [])

  // heavily influenced by the ngRepeat expresion parser
  .factory('multiselectOptionParser',
    [
      '$parse', function($parse) {
        return {
          parse: function(expression) {
            var keyIdentifier;
            var valueIdentifier;
            var disabledIdentifier;
            var hiddenIdentifier;
            var initiallyChecked;
            var initialState;
            var dividerIdentifier;
            var r;


            var multiselectOptionErr = function(code, message, argument) {
              throw message.replace('OptionParser: {0}', argument);
            }

            var match = expression.match(
              /^\s*([({])([\s\S]+?)\s+for\s+?([\s\S]+?)\s+?in\s+([\s\S]+?)(?:\s+with\s+([\s\S]+?))?\s*$/);

            if (!match) {
              // throw
              multiselectOptionErr('iexp',
                'Expected expression in form of \'_item_ in _collection_[ with _children_]\' but got \'{0}\'.',
                expression);
            }

            var format = match[1];
            var lhs = match[2];
            var rhs = match[3];
            var source = match[4];
            var children = match[5];


            if (format === '(') {
              // lhs starts with (, then it is this format
              // (id, label) [initially checked];
              match = lhs.match(/^(?:\s*([\w]+\.[\w]+)\s*,\s*([\w]+\.[\w]+)\s*\)(\sinitially\s+[\w]+)?\s*)$/);

              keyIdentifier = match[1] || match[2];
              valueIdentifier = match[2];
              initialState = match[3];

              initiallyChecked =
                (initialState !== undefined && initialState.toLocaleLowerCase().indexOf("checked") !== -1);

              r = {
                id: $parse(keyIdentifier),
                label: $parse(valueIdentifier),
                itemName: rhs,
                initiallyChecked: initiallyChecked,
                disabled: function(s) {
                  if (s == null) return undefined;
                  return s[rhs].disabled;
                },
                hidden: function(s) {
                  if (s == null) return undefined;
                  return s[rhs].hidden;
                },
                divider: function(s) {
                  if (s == null) return undefined;
                  return s[rhs].divider;
                },

                viewMapper: $parse(match[2] || match[1]),
                children: $parse(children),
                source: $parse(source)
              };


            } else {
              //otherwise it is this format:
              // {id:<keyIdentifier>, label:<valueIdentifier>, checked<initialStatus> disabled:<disabledIdentifier>, hidden:<hiddenIdentifier>, type:<typeIdentifier>}
              var f = "{" + match[2];
              // match = lhs.match(/^\s*\(\s*([\s\S]+)\s*\)(\s+initially\s[\w]+)?\s*$/);
              var fields = JSON.parse(f);


              keyIdentifier = fields.id || fields.label;
              valueIdentifier = fields.label;
              disabledIdentifier = fields.disabled;
              hiddenIdentifier = fields.hidden;
              initiallyChecked = fields.initialState;
              dividerIdentifier = fields.divider;

              // if (!match) {
              //   //throw
              //   multiselectOptionErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be a \'(_key_, _value_)\' expression with optionalinitial state (initially checked), but got \'{0}\'.',
              //     lhs);
              // }

              r = {
                id: $parse(keyIdentifier),
                label: $parse(valueIdentifier),
                itemName: rhs,
                initiallyChecked: initiallyChecked,
                disabled: $parse(disabledIdentifier),
                hidden: $parse(hiddenIdentifier),

                divider: $parse(dividerIdentifier),

                children: $parse(children),
                source: $parse(source)
              };
            }

            return r;
          }
        };
      }
    ])
  .directive('multiselect',
    [
      '$parse', '$document', '$compile', '$interpolate', '$filter', 'multiselectOptionParser', '$timeout',
      function($parse, $document, $compile, $interpolate, $filter, multiselectOptionParser, $timeout) {
        return {
          restrict: 'E',
          require: 'ngModel',
          link: function(originalScope, element, attrs, modelCtrl) {
            // Redefine isEmpty - this allows this to work on at least Angular 1.2.x
            var isEmpty = modelCtrl.$isEmpty;
            modelCtrl.$isEmpty = function(value) {
              return isEmpty(value) || (angular.isArray(value) && value.length == 0);
            };

            var exp = attrs.options,
              parsedResult = multiselectOptionParser.parse(exp),
              isMultiple = attrs.multiple ? true : false,
              required = false,
              scope = originalScope.$new(),
              changeHandler = attrs.change || angular.noop,
              disableSelectedItems = attrs.disableSelectedItems ? true : false;

            var showFilter = attrs.showFilter === "true" ? true : false,
              sortList = attrs.sortList;

            var showCheckAll = attrs.showCheckAll === "true" ? true : false,
              showUncheckAll = attrs.showUncheckAll === "true" ? true : false,
              getDataItems = attrs.getDataItems || angular.noop,
              maxHeight = attrs.maxHeight, // '<x>px | 'fit'
              // maxWidth = attrs.maxWidth,   // '<x>px' | 'fit'
              optionsInitiallyChecked = (attrs.optionsInitiallyChecked === "true" ? true : false) || false,
              flattenModel = (attrs.flattenModel === "true" ? true : false) || false,
              noneCheckedDoneButtonLabel = attrs.noneCheckedDoneButtonLabel || 'done',
              doneButtonLabel = attrs.doneButtonLabel || 'done';

            scope.searchText = {
              label: ""
            };

            scope.maxHeight = attrs.maxHeight;
            if (!scope.maxHeight) {
              scope.maxHeight = "300px";
            } else if (scope.maxHeight.toLowerCase() == 'fit') {
              scope.maxHeight = "1000px";
            }


            scope.rawUnselectedHeaderTemplate = element.attr(attrs.$attr.msHeader);
            scope.rawSelectedHeaderTemplate = element.attr(attrs.$attr.msSelected);


            scope.showFilter = showFilter;
            scope.showCheckAll = showCheckAll;
            scope.showUncheckAll = showUncheckAll;

            scope.showMultipleToggle = attrs.showMultipleToggle ? true : false;

            scope.singleSelectAction = attrs.singleSelectAction;
            scope.multiSelectAction = attrs.multiSelectAction;

            scope.btnClass = attrs.btnClass || 'btn-default';

            scope.doneButtonLabel = function() {
              if (!modelCtrl.$viewValue) return noneCheckedDoneButtonLabel;

              if (modelCtrl.$viewValue.length == 0) return noneCheckedDoneButtonLabel;
              else return doneButtonLabel;
            };


            scope.items = [];
            // scope.header = 'Select';
            scope.multiple = isMultiple;
            scope.disabled = false;
            scope.onBlur = attrs.ngBlur || angular.noop;
            scope.optionsInitiallyChecked = optionsInitiallyChecked;
            scope.flattenModel = flattenModel;
            scope.filterProperty = attrs.filterProperty;
            scope.filterRegexPattern = attrs.filterRegexPattern || /^.*$/;

            showCheckAll = showCheckAll === "true" ? true : false;
            showUncheckAll = showUncheckAll === "true" ? true : false;

            //minimal no of characters that needs to be entered before typeahead kicks-in
            var minSearch = scope.$eval(attrs.typeaheadMinLength) || 0;

            //minimal wait time after last character typed before typehead kicks-in
            var waitTime = scope.$eval(attrs.typeaheadWaitMs) || 0;
            //
            //should it restrict model values to the ones selected from the popup only?
            var isEditable = scope.$eval(attrs.typeaheadEditable) !== false;
            //
            //binding to a variable that indicates if matches are being retrieved asynchronously
            var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

            scope.require = attrs.require || "optional";
            // if the require value changes, reevaluate the control's valididty
            attrs.$observe('require',
              function(val) {
                scope.require = val.toLowerCase();
                modelCtrl.$setValidity('required', scope.valid());
              });

            originalScope.$on('$destroy',
              function() {
                scope.$destroy();
              });


            scope.toggleMultiple = function() {
              isMultiple = !isMultiple;
              scope.multiple = isMultiple;

              // run the multiple toggle action supplied from outside
              scope.$eval(attrs.multipleToggleAction);

              // recompute the header text in case the toggle control has done
              // anything to change the interpolated text
              getHeaderText();
            };

            var resetMatches = function() {

            };


            ///////////////////////////////////////////////////////////////////////////////////////////////////
            // ListItem Constructor
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            var ListItem =
              function(sourceItem,
                parent) { // , idField, labelField, isChecked, childrenField) { //, checkedChildren) {
                var me = this;

                var local = {};
                local[parsedResult.itemName] = sourceItem;

                var getId = function() {
                  return parsedResult.id(local);
                };
                var getLabel = function() {
                  return parsedResult.label(local);
                };
                var getInitialState = function() {
                  return parsedResult.initiallyChecked;
                };
                var getDisabledState = function() {
                  return parsedResult.disabled(local);
                };
                var getHiddenState = function() {
                  return parsedResult.hidden(local);
                };
                var getDividerState = function() {
                  return parsedResult.divider(local);
                }
                var getChildren = function() {
                  var children = parsedResult.children(local);
                  if (!children || children.length === 0) return [];

                  // children must be wrapped as listitems before returning
                  var childlistItems = children.map(function(child) {
                    var newListItem = new ListItem(child, me);
                    return newListItem;
                  });

                  //var childlistItems = [];
                  //for (var i = 0, imax = children.length; i < imax; i++) {
                  //  childlistItems.push(new ListItem(children[i]));
                  //}

                  return childlistItems;
                };

                this.id = getId();
                this.label = getLabel();
                this.divider = getDividerState();
                this.children = getChildren();
                this.checked = getInitialState();
                this.initiallyChecked = getInitialState();
                //  this.disabled = getDisabledState() || false;
                this.disabled = getDisabledState() || false;
                this.hidden = getHiddenState() || false;
                this.model = sourceItem;

                if (parent) this.parent = parent;
              };

            ///////////////////////////////////////////////////////////////////////////////////////////////////

            var popUpEl = angular.element('<multiselect-popup></multiselect-popup>');

            //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
            var timeoutPromise;
            var hasFocus;

            //a callback executed when a match is selected
            var getMatchesAsync = function(inputValue) {
              //scope.getDataItems(inputValue);
              scope.$eval(attrs.getDataItems + "(inputValue)", { "inputValue": inputValue });
            };


            scope.filterOn = function(filterProperty, filterValue) {
              var obj = {};

              obj[filterProperty] = filterValue;
              return obj;
            };


            scope.$watch("searchText.label",
              function() {
                var inputValue = scope.searchText.label;


                // check for number of characters and time since last  em(it
                if (inputValue && inputValue.length >= minSearch) {
                  if (waitTime > 0) {
                    if (timeoutPromise) {
                      $timeout.cancel(timeoutPromise); //cancel previous timeout
                    }
                    timeoutPromise = $timeout(function() {
                        getMatchesAsync(inputValue);
                      },
                      waitTime);
                  } else {
                    getMatchesAsync(inputValue);
                  }
                } else {
                  isLoadingSetter(scope, false);
                  resetMatches();
                }

                if (isEditable) {
                  return inputValue;
                } else {
                  if (!inputValue) {
                    // Reset in case user had typed something previously.
                    modelCtrl.$setValidity('editable', true);
                    return inputValue;
                  } else {
                    modelCtrl.$setValidity('editable', false);
                    return undefined;
                  }
                }

              });


            // required validator
            if (attrs.required || attrs.ngRequired) {
              required = true;
            }
            attrs.$observe('required',
              function(newVal) {
                required = newVal;
              });


            // not sure this is necessary anymore
            //   // give the multiselect control
            //   // a jquery-compatible .val() method
            //   // this will return a comma-delimeted list of selected items
            // element.val = function () {
            //   var selectedIDs = [];
            //   for (var i = 0; i < items.length; i++) {
            //     selectedIDs.push(items[i].value);
            //   }
            //   return selectedIDs.join(",");
            // };


            // watch disabled state
            scope.$watch(function() {
                return $parse(attrs.disabled)(originalScope);
              },
              function(newVal) {
                scope.disabled = newVal;
              });


            // watch single/multiple state for dynamically change single to multiple
            scope.$watch(function() {
                return $parse(attrs.multiple)(originalScope);
              },
              function(newVal) {
                isMultiple = newVal || false;
                scope.multiple = isMultiple;
              });

            var setInitiallyCheckedModel = function() {
              var initiallyChecked = false;
              for (var i = 0, max = scope.items.length; i < max; i++) {
                if (scope.items[i].initiallyChecked == true) {
                  initiallyChecked = true;
                  break;
                }
              }

              if (initiallyChecked) {
                // Add new items to the model
                // find out if the control is dirty,
                // set the moel value then put the control's
                // status back afterwards to preserve the state
                // because setting the model value may alter it
                var isPristine = modelCtrl.$pristine;
                var isValid = modelCtrl.$isValid;

                setModelValue(true);

                if (isPristine) modelCtrl.$setPristine();
                if (isValid) modelCtrl.$setValidity('required', true);

                // this only seems to be needed when adding items
                // to synch up with the model.
                // i  think this is because of the way the timing works
                //scope.$apply();
              }
            };

            var parseModel = function() {
              scope.items.length = 0;
              var model = parsedResult.source(originalScope);

              // sort by a specified field
              // skip if no sort specification is given or no model has been set up
              if (sortList && model) {
                model = model.sort(function(a, b) {
                  return (a[sortList] > b[sortList]) ? 1 : ((b[sortList] > a[sortList]) ? -1 : 0);
                });
              }

              if (!angular.isDefined(model)) return;
              for (var i = 0, imax = model.length; i < imax; i++) {
                // create and push the listItem for hierachical display
                const listitem = new ListItem(model[i]);
                scope.items.push(listitem);
              }

            };

            // watch option changes for options that are populated dynamically
            scope.$watch(function() {
                return parsedResult.source(originalScope);
              },
              function(newVal, oldVal) {
                if (angular.isDefined(newVal)) {
                  // parse the list of options into scope.items
                  // check any items that appear in the model
                  parseModel();

                  $timeout(function() {
                    setInitiallyCheckedModel();
                    if (modelCtrl.$modelValue) markChecked(modelCtrl.$modelValue);
                  });
                }

              },
              true);


            // watch model change
            scope.$watch(function() {
                return modelCtrl.$modelValue;
              },
              function(newVal, oldVal) {
                // when directive initialize, newVal usually undefined. Also, if model value already set in the controller
                // for preselected list then we need tomark checked in our scope item. But we don't want to do this every time
                // model changes. We need to do this only if it is done outside directive scope, from controller, for example.
                if (angular.isDefined(newVal)) {
                  markChecked(newVal);
                  scope.$eval(changeHandler);
                }
                getHeaderText();
                modelCtrl.$setValidity('required', scope.valid());
              },
              true);


            parseModel();

            element.append($compile(popUpEl)(scope));


            function getHeaderText() {
              if (is_empty(modelCtrl.$modelValue))
                return scope.header = (attrs.msHeader !== undefined
                  ? $interpolate(scope.rawUnselectedHeaderTemplate)(scope)
                  : 'Select');

              if (isMultiple) {
                if (attrs.msSelected) {
                  scope.header = $interpolate(scope.rawSelectedHeaderTemplate)(scope);
                } else {
                  if (modelCtrl.$modelValue.length == 1) {
                    for (var i = 0; i < scope.items.length; i++) {
                      if (scope.items[i].model === modelCtrl.$modelValue[0]) {
                        scope.header = scope.items[i].label;
                      }
                    }
                  } else {
                    scope.header = modelCtrl.$modelValue.length + ' ' + 'selected';
                  }
                }
              } else {
                if (angular.isString(modelCtrl.$modelValue)) {
                  scope.header = modelCtrl.$modelValue;
                } else {
                  var local = {};
                  local[parsedResult.itemName] = modelCtrl.$modelValue;
                  scope.header = parsedResult.viewMapper(local) || scope.items[modelCtrl.$modelValue].label;
                }
              }
            };

            function is_empty(obj) {
              if (angular.isNumber(obj)) return false;
              if (obj && obj.length && obj.length > 0) return false;
              if (typeof obj != "undefined" && obj != null && obj.length == 0
              ) return true; //  I put this line in  - its empty if its a zero=length array!
              for (var prop in obj) if (obj[prop]) return false;

              return true;
            };


            // require
            // Extends the concept of being 'required'
            //   require='yes'      - the field must be filled in
            //   require='no'       - the field must *not* be filled in
            //   require='optional' -  the filed may be filled in (default case)
            scope.valid = function validModel() {
              var value = modelCtrl.$modelValue;

              if (scope.require == 'no') {
                return (angular.isArray(value) && value.length == 0) || (!angular.isArray(value) && value == null);
              } else if (scope.require == 'yes') {
                return (angular.isArray(value) && value.length > 0) || (!angular.isArray(value) && value != null);
              } else { // optional
                return true;
              }
            };

            scope.dirty = function() {
              return modelCtrl.$dirty;
            };


            var selectSingle = function(item) {
              if (item.checked) {
                scope.uncheckAll();
              } else {
                scope.uncheckAll();
                item.checked = true; //!item.checked;
              }
              setModelValue(false);
            };


            var setCheckedStatus = function(item, newStatus) {
              item.checked = newStatus;

              if (item.children.length > 0) {
                for (var i = 0, imax = item.children.length; i < imax; i++) {
                  var child = item.children[i];
                  child.checked = newStatus;
                }
              }
            };

            var selectMultiple = function(item) {
              setCheckedStatus(item, !item.checked);
              setModelValue(true);
            };


            function setModelValue(isMultiple) {
              var value = null;

              if (isMultiple) {
                value = [];


                angular.forEach(scope.items,
                  function(item) {
                    // Check to see if we are to put out a hierachical or flattened model
                    if (scope.flattenModel) {
                      // push the selected parents and children intot he same list
                      if (item.checked) {
                        value.push(item.model);
                      }
                      angular.forEach(item.children,
                        function(child) {
                          if (child.checked)
                            value.push(child.model);
                        });
                    } else {
                      // keep the model hierachical
                      // this has two consequences
                      // 1. there must be a parent
                      // 2. it is the containing applications business to deal with children
                      if (item.checked) {
                        value.push(item.model);
                      }
                    }


                  });
              } else {
                angular.forEach(scope.items,
                  function(item) {
                    if (item.checked) {
                      value = item.model;
                      return false;
                    }
                  });
              }

              modelCtrl.$setViewValue(value);
            };


            function markChecked(newVal) {
              if (!angular.isArray(newVal)) {
                angular.forEach(scope.items,
                  function(item) {
                    if (angular.equals(item.model, newVal)) {
                      scope.uncheckAll();
                      item.checked = true;
                      setModelValue(false);
                      return false;
                    }
                  });
              } else {
                angular.forEach(scope.items,
                  function(item) {
                    item.checked = false;
                    angular.forEach(newVal,
                      function(i) {
                        if (angular.equals(item.model, i)) {
                          item.checked = true;
                        }
                      });
                  });
              }
            };


            scope.checkAll = function() {
              if (!isMultiple) return;
              var items = (scope.searchText && scope.searchText.label.length > 0)
                ? $filter('filter')(scope.items, scope.searchText)
                : scope.items;
              angular.forEach(items,
                function(item) {
                  setCheckedStatus(item, true);
                });
              setModelValue(true);
            };


            scope.uncheckAll = function() {
              var items = (scope.searchText && scope.searchText.label.length > 0)
                ? $filter('filter')(scope.items, scope.searchText)
                : scope.items;
              angular.forEach(items,
                function(item) {
                  setCheckedStatus(item, false);
                });
              setModelValue(true);
            };


            scope.select = function(item) {
              if (isMultiple === false) {
                selectSingle(item);
                scope.toggleSelect();
              } else {
                selectMultiple(item);
              }
            };

          }
        };
      }
    ])
  .directive('multiselectPopup',
    [
      '$document', '$filter', function($document, $filter) {
        return {
          restrict: 'E',
          scope: false,
          replace: true,
          templateUrl: '/assets/multiselect.tmpl.html',
          link: function (scope, element, attrs) {
            scope.selectedIndex = null;
            scope.isVisible = false;
            scope.filteredItems = null;

            scope.toggleSelect = function() {
              if (scope.searchText) scope.searchText.label = "";

              if (element.hasClass('open')) {
                scope.close();
                $document.unbind('click', clickHandler);
                scope.$parent.$eval(scope.onBlur);
              } else {
                element.addClass('open');
                $document.bind('click', clickHandler);
                scope.focus();
              }
            };

            function clickHandler(event) {
              if (elementMatchesAnyInArray(event.target, element.find(event.target.tagName))) {
                scope.$parent.$eval(scope.onBlur);
              } else {
                scope.close();
                $document.unbind('click', clickHandler);
                scope.$apply();
              }
            };

            scope.focus = function focus() {
              var searchBox = element.find('input')[0];
              if (searchBox) {
                searchBox.focus();
              }
            };

            scope.hidden = function(item) {
              return !item.hidden;
            };


            scope.keydown = function(event) {

              var list = scope.items;
              var keyCode = (event.keyCode || event.which);

              if (keyCode === 13) { // On enter
                if (list[scope.selectedIndex]) {
                  scope.select(list[scope.selectedIndex]); // (un)select item
                }
              } else if (keyCode === 38) { // On arrow up
                scope.selectedIndex = scope.selectedIndex === null ? list.length - 1 : scope.selectedIndex - 1;
              } else if (keyCode === 40) { // On arrow down
                scope.selectedIndex = scope.selectedIndex === null ? 0 : scope.selectedIndex + 1;
              } else { // On any other key
                scope.selectedIndex = null;
              }

              if (scope.selectedIndex < 0) { // Select last in list
                scope.selectedIndex = list.length - 1;
              } else if (scope.selectedIndex > list.length - 1) { // Set selection to first item in list
                scope.selectedIndex = 0;
              }
            };

            scope.close = function() {
              if (scope.multiple) {
                if (scope.multiSelectAction) {
                  scope.$eval(scope.multiSelectAction); //+ "()"
                }
              } else {
                if (scope.singleSelectAction) {
                  scope.$eval(scope.singleSelectAction); // + "()"
                  scope.uncheckAll();
                }
              }

              if (scope.searchText) scope.searchText.label = "";
              element.removeClass('open');
            };

            var elementMatchesAnyInArray = function(element, elementArray) {
              for (var i = 0; i < elementArray.length; i++)
                if (element == elementArray[i])
                  return true;
              return false;
            };
          }
        }
      }
    ])
  .directive('multiselectListItem',
    [
      function() {
        return {
          restrict: 'E',
          priority: 11, // default is 0 (ie last)
          scope: false,
          replace: true,
          templateUrl: '/assets/multiselectListItem.tmpl.html',
          link: function(scope, element, attrs) {

            scope.isVisible = false;
          }
        }
      }
    ])
  .provider('adrConfig',
    function adrConfigProvider() {
      //defaults
      var defaultConfig = {
        iconPosition: [0, 0],
        mode: 'all',
        modes: ['all', 'horizontal', 'vertical']
      };
      var config = angular.extend({}, defaultConfig);
      this.$get = [
        function() {
          return {
            iconPosition: config.iconPosition,
            mode: config.mode,
            modes: config.modes
          };
        }
      ];
    })
  .directive('multiselectResize',
    [
      'adrConfig', '$document', '$timeout', function(adrConfig, $document, $timeout) {
        return {
          restrict: 'A',
          link: function(scope, element, attr) {
            $timeout(function () {

                element.on('$destroy',
                  function() {
                    // ensure that  all watchers attached to this scope get cleaned up
                    scope.$destroy();
                  });

                var ctrlContainer = element.find(".dropdown-menu");
                var multiselectFilter = element.find(".multiselect-filter");
                var multiselectScrollContainer = element.find(".multiselect-scroll-container");


                var filterVisible = multiselectFilter[0] ? true : false;
                // optionCount = function() {
                //  return element.find(".multiselect-scroll-container.li").length;
                //};

                var dimension = {};
                var iconPosition = adrConfig.iconPosition;
                var mode = attr.resize && adrConfig.modes.indexOf(attr.resize) > -1 ? attr.resize : adrConfig.mode;
                var position = {};
                //create button for resizing
                var btn = document.createElement("span");
                btn.style.width = '15px';
                btn.style.height = '15px';
                btn.innerHTML = "<svg>\
            <circle cx='12.5' cy='2.5' r='2' fill='#777777'></circle>\
            <circle cx='7.5' cy='7.5' r='2' fill='#777777'></circle>\
            <circle cx='12.5' cy='7.5' r='2' fill='#424242'></circle>\
            <circle cx='2.5' cy='12.5' r='2' fill='#777777'></circle>\
            <circle cx='7.5' cy='12.5' r='2' fill='#424242'></circle>\
            <circle cx='12.5' cy='12.5' r='2' fill='#212121'></circle></svg>";
                btn.style.bottom = iconPosition[0] + 'px';
                btn.style.right = iconPosition[1] + 'px';
                btn.style.position = 'absolute';
                btn.style.visibility = 'hidden';
                if (mode == 'horizontal') {
                  btn.style.cursor = 'ew-resize';
                } else if (mode == 'vertical') {
                  btn.style.cursor = 'ns-resize';
                } else {
                  btn.style.cursor = 'nwse-resize';
                }

                scope.$watch(function() {
                    return multiselectScrollContainer.find("li").length;
                  },
                  function(newValue, oldValue) {
                    if (newValue === oldValue) return;
                    btn.style.visibility = newValue ? 'visible' : 'hidden';
                  });

                //bind resize function to button;
                btn.onmousedown = function($event) {
                  $event.stopImmediatePropagation();
                  position.x = $event.clientX;
                  position.y = $event.clientY;
                  dimension.width = ctrlContainer.prop('offsetWidth');
                  dimension.height = ctrlContainer.prop('offsetHeight');
                  $document.bind('mousemove', mousemove);
                  $document.bind('mouseup', mouseup);
                  return false;
                };

                function mousemove($event) {
                  var multiSelectScrollContainer = element.find(".multiselect-scroll-container");

                  var deltaWidth = dimension.width - (position.x - $event.clientX);
                  var deltaHeight = dimension.height - (position.y - $event.clientY);
                  var newDimensions = {};
                  if (mode == 'horizontal') {
                    newDimensions = {
                      width: deltaWidth + 'px'
                    };
                  } else if (mode == 'vertical') {
                    newDimensions = {
                      height: deltaHeight + 'px'
                    };


                  } else {
                    newDimensions = {
                      width: deltaWidth + 'px',
                      height: deltaHeight + 'px'
                    };
                  }
                  ctrlContainer.css(newDimensions);
                  var effectiveHeight = deltaHeight - 34 - (filterVisible ? 28 : 0);
                  var multiSelectScrollContainerDimensions = {
                    height: effectiveHeight + 'px',
                    maxHeight: "1000px"
                  };
                  multiSelectScrollContainer.css(multiSelectScrollContainerDimensions);

                  return false;
                }

                function mouseup() {
                  $document.unbind('mousemove', mousemove);
                  $document.unbind('mouseup', mouseup);
                }

                ctrlContainer.append(btn);


                //show button on hover
                //element.bind('mouseover',
                //  function() {
                //    btn.style.visibility = 'visible';
                //  });
                //element.bind('mouseout',
                //  function() {
                //    btn.style.visibility = 'hidden';
                //  });
              },
              0);
          }

        };
      }
  ])

  .directive('dropdownDraggable',
    [
      '$document', function($document) {
        return {
          restrict: 'A',
          link: function(scope, element) {
            var position = {};
            element.bind('mousedown',
              function($event) {
                //element.css({position: 'fixed'});
                position.x = element[0].getBoundingClientRect().left;
                position.y = element[0].getBoundingClientRect().top;
                position.initialMouseX = $event.clientX;
                position.initialMouseY = $event.clientY;
                $document.bind('mousemove', mousemove);
                $document.bind('mouseup', mouseup);
                return false;
              });

            function mousemove($event) {
              var dx = $event.clientX - position.initialMouseX;
              var dy = $event.clientY - position.initialMouseY;
              element.css({
                top: position.y + dy + 'px',
                left: position.x + dx + 'px'
              });
              return false;
            }

            function mouseup() {
              $document.unbind('mousemove', mousemove);
              $document.unbind('mouseup', mouseup);
            }
          }
        };
      }
    ]);
